export default "__VITE_ASSET__09a7cd72__"